module.exports = __webpack_public_path__ + "static/media/transport_without_wheels.ecf2079e.svg";